/* eslint-disable no-console */
// Third-party libraries
import React, { Component } from "react";

// Project dependencies
import FileNotFound from "./FileNotFound";
import { LoadingBar } from "../components/widgets";
import {
  getHeaders,
  errorHandler,
  betsUrl,
  propositionUrl,
} from "../apihelpers";
import { Meta } from "../utilities";
import AdminTools from "../components/AdminTools";
import BetMessages from "../components/BetMessages";
import OptionComponent from "../components/Option";
import Histories from "../components/Histories";
import PropLabel from "../components/PropLabel";
import PropositionMeta from "../components/PropositionMeta";
import ScratchList from "../components/ScratchList";
import {
  Bet,
  OptionData,
  ProposedBet,
  Proposition,
} from "../shared/interfaces";

class PropositionPage extends Component {
  slug = this.props.match.params.slug;
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      betMessages: [],
      proposedBets: [],
      suggestion: null,
      loading: false,
      notFound: false,
      existingBets: [],
      firstBet: false,
      favorite: null,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.addToBet = this.addToBet.bind(this);
    this.resetBet = this.resetBet.bind(this);
    this.makeSingleBet = this.makeSingleBet.bind(this);
    this.getProposition = this.getProposition.bind(this);
  }

  proposedTotal = () =>
    this.state.proposedBets && this.state.proposedBets.length > 0
      ? this.state.proposedBets.reduce((a, b) => ({
          amount: a.amount + b.amount,
        })).amount
      : 0;

  existingTotal = (): number =>
    this.state.existingBets.length > 0
      ? this.state.existingBets.reduce((a, b) => ({
          amount: a.amount + b.amount,
        })).amount
      : 0;

  addToBet(event) {
    // This gets fired by the +10 and +25 buttons
    let amount = parseInt(event.target.value.split(",")[0]),
      option_data_id = parseInt(event.target.value.split(",")[1]),
      proposedBets = this.state.proposedBets.slice();

    proposedBets = proposedBets.map((bet: Bet) => {
      if (bet.option_data_id === option_data_id) {
        bet.amount += amount;
      }
      return bet;
    });

    this.setState({
      proposedBets: proposedBets,
    });

    event.preventDefault();
  }

  handleChange(event) {
    // This gets fired if someone manually enters a bet,
    // without the shortcut buttons
    const option_data_id = parseInt(event.target.name);
    let value = parseInt(event.target.value.replace(",", ""));
    value = value || 0; // Ensures empty string stays an integer

    let proposedBets = this.state.proposedBets.filter(
      (bet) => bet.option_data_id !== option_data_id
    );
    proposedBets.push({ option_data_id: option_data_id, amount: value });

    this.setState({
      proposedBets: proposedBets,
    });
  }

  makeSingleBet(event) {
    let option_data_id = parseInt(event.target.value);
    let amount = this.state.proposedBets.find(
      (bet) => bet.option_data_id === option_data_id
    ).amount;
    this.makeBets([{ option_data_id: option_data_id, amount: amount }]).then(
      () => {
        this.getProposition();
        this.props.getPlayer();
        window.scrollTo(0, 0);
      }
    );
  }

  resetBet(event) {
    let option_data_id = parseInt(event.target.value),
      proposedBets = this.state.proposedBets.slice();

    proposedBets = proposedBets.map((bet) => {
      if (bet.option_data_id === option_data_id) {
        bet.amount = 0;
      }
      return bet;
    });

    this.setState({
      proposedBets: proposedBets,
    });
  }

  getProposition() {
    if (
      localStorage.getItem(this.slug) &&
      this.state.betMessages.length === 0
    ) {
      // this.state.betMessages is a proxy for whether this is a new visit
      // to a page or a reload after a bet.
      const local_proposition = JSON.parse(
        localStorage.getItem(this.slug) || ""
      );
      let local_proposedBets = [];
      if (localStorage.getItem(this.slug + "-proposedBets")) {
        local_proposedBets = JSON.parse(
          localStorage.getItem(this.slug + "-proposedBets") || ""
        );
      }

      this.setState({
        proposition: local_proposition,
        proposedBets: local_proposedBets,
      });
    } else {
      this.setState({
        loading: true,
      });
    }

    const headers = getHeaders(true);
    fetch(propositionUrl + "/" + this.slug + "?" + Date.now(), {
      method: "GET",
      headers,
    })
      .then(errorHandler)
      .then((data) => {
        let proposedBets: Array<ProposedBet> = [];
        // See who the current favorite is by seeing which has the most
        // points bet (sum) combined with the biggest morning line (seed)
        let favorite: OptionData | null = null;
        data.options
          .filter((option) => option.scratch === false)
          .map((option) => {
            if (favorite === null) {
              favorite = option;
            } else if (option.payout < favorite.payout) {
              favorite = option;
            }
            return true;
          });

        // If there are no proposed bets yet, create an array and populate
        // it with bets of 0
        if (this.state.proposedBets.length === 0) {
          data.options.forEach((option) => {
            proposedBets.push({ option_data_id: option.id, amount: 0 });
          });
        } else {
          // But if there are existing bets, it means we've just tried to make
          // bets. Clear out any bet values for the successful bets.
          const betMessages = this.state.betMessages;
          const successfulBets = betMessages
            .filter((message) => message.status === "success")
            .map((message) => message.option_data_id);

          proposedBets = this.state.proposedBets.slice().map((bet) => {
            // If this was a successful bet, reset the value to 0
            if (successfulBets.includes(bet.option_data_id)) {
              bet.amount = 0;
            }
            return bet;
          });
        }
        if (navigator.userAgent !== "ReactSnap") {
          localStorage.setItem(this.slug, JSON.stringify(data));
          localStorage.setItem(
            this.slug + "-proposedBets",
            JSON.stringify(proposedBets)
          );
        }
        if (this._isMounted) {
          this.setState(
            {
              proposition: data,
              proposedBets: proposedBets,
              loading: false,
              favorite: favorite,
            },
            () => {
              if (this.props.loggedIn) {
                this.getExistingBets();
              }
            }
          );
        }
      })
      .catch((error) => {
        console.log(error);
        if (this._isMounted) {
          this.setState({ notFound: true });
        }
      });
  }

  getExistingBets() {
    const headers = getHeaders();
    fetch(betsUrl + "/" + this.slug + "?" + Date.now(), {
      method: "GET",
      headers,
    })
      .then(errorHandler)
      .then((data) => {
        if (this._isMounted) {
          this.setState({
            existingBets: data,
          });
        }
      })
      .catch((error) => {
        console.log(error);
        this.props.logout();
      });
  }

  makeBets(proposedBets: Array<ProposedBet>) {
    proposedBets.map((bet) => {
      const option = this.state.proposition.options.find(
        (data) => data.id === bet.option_data_id
      ).option.name;
      let w: any;
      w = window;

      return w.gtag("event", "try", {
        event_category: "bet",
        event_label: this.state.proposition.name,
        dimension1: this.state.proposition.race
          ? this.state.proposition.race.name
          : null,
        dimension2: this.state.proposition.name,
        dimension3: option,
        dimension4: bet.amount.toString(),
      });
    });

    return new Promise((resolve, reject) => {
      let headers = getHeaders();
      fetch(betsUrl, {
        method: "POST",
        headers,
        body: JSON.stringify({
          proposition_id: this.state.proposition.id,
          bets: proposedBets,
        }),
      })
        .then((res) => res.json())
        .then(
          (data: {
            first_bet: boolean;
            suggested_prop: Proposition;
            betMessages: Array<{
              amount: number;
              message: string;
              option: string;
              status: string; // 'error' or 'success'
            }>;
          }) => {
            let w: any;
            w = window;
            data.betMessages.map((message) => w.gtag("event", message.status, {
                event_category: "bet",
                event_label:
                  this.state.proposition.name + " / " + message.message,
                dimension1: this.state.proposition.race
                  ? this.state.proposition.race.name
                  : "No race",
                dimension2: this.state.proposition.name,
                dimension3: message.option,
                dimension4: message.amount.toString(),
                metric1: message.status === "success" ? message.amount : null,
              }));

            this.setState(
              {
                betMessages: data.betMessages,
                firstBet: data.first_bet || false,
                suggestion: data.suggested_prop,
              },
              () => {
                resolve(true);
              }
            );
          }
        )
        .catch((error) => {
          console.log("error" + error);
          reject(error);
        });
    });
  }

  componentDidMount() {
    this._isMounted = true;
    this.getProposition();
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps) {
    // Check to see if the player is newly logged in
    if (
      prevProps.loggedIn === false &&
      this.props.loggedIn === true &&
      this.state.proposition &&
      this.state.proposition.status !== 4
    ) {
      this.setState({ betMessages: [], firstBet: false }); // Reset a few things
      this.getExistingBets();
    }

    // Check to see if the location changes. If it has, reset the state and
    // get the new proposition. This allows us to link to other propositions
    // within the Proposition component.
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.slug = this.props.match.params.slug;
      let localProposedBets = [];
      if (localStorage.getItem(this.slug + "-proposedBets")) {
        localProposedBets = JSON.parse(
          localStorage.getItem(this.slug + "-proposedBets") || ""
        );
      }
      let localProposition = null;
      if (localStorage.getItem(this.slug)) {
        localProposition = JSON.parse(
          localStorage.getItem(this.slug) || ""
        );
      }

      this.setState(
        {
          proposedBets: localProposedBets,
          proposition: localProposition,
          existingBets: [],
          betMessages: [],
          firstBet: false,
          favorite: null,
          // loading: true
        },
        () => {
          this.getProposition();
        }
      );
    }
  }

  handleSubmit(event) {
    this.setState({ loading: true });

    // Send all the bets to the backend
    this.makeBets(this.state.proposedBets.filter((bet) => bet.amount > 0)).then(
      () => {
        this.getProposition();
        this.props.getPlayer();
        window.scrollTo(0, 0);
      }
    );

    event.preventDefault();
  }

  // Evaluate proposedBets and evaluate whether they are valid.
  // Among other potential uses, this will determine whether the submit button
  // should be disabled or not.
  // eslint-disable-next-line class-methods-use-this
  validateBets(proposedBets: Array<ProposedBet>): boolean {
    if (proposedBets.length === 0) {
      return false;
    }
    const betTotal = proposedBets.reduce((a, b) => ({
      amount: (a.amount || 0) + (b.amount || 0),
    })).amount;
    if (betTotal <= 0) return false;
    else return true;
  }

  render() {
    if (this.state.notFound) {
      return <FileNotFound />;
    }

    if (this.state.proposition) {
      return (
        <article>
          <Meta
            title={`Rouleur Derby: ${this.state.proposition.question}`}
            description={`Go to Rouleur Derby to get the latest odds for this proposition (${this.state.proposition.name}).`}
          />

          {(this.state.proposition.race || this.state.proposition.contest) && (
            <PropLabel proposition={this.state.proposition} />
          )}
          <h1>{this.state.proposition.question}</h1>

          {this.props.loggedIn && this.props.player.is_staff && (
            <AdminTools
              proposition={this.state.proposition}
              getProposition={this.getProposition}
            />
          )}

          {this.state.betMessages.length > 0 && this.props.loggedIn && (
            <BetMessages
              messages={this.state.betMessages}
              firstBet={this.state.firstBet}
              suggestion={this.state.suggestion}
            />
          )}

          <section className="proposition__content">
            <PropositionMeta
              existingBets={this.state.existingBets}
              existingTotal={this.existingTotal()}
              favorite={this.state.favorite}
              loggedIn={this.props.loggedIn}
              availablePoints={this.props.player.points || 0}
              proposition={this.state.proposition}
            />

            <section className="proposition__options">
              <div className="proposition__header-and-options">
                <div className="option__header">
                  <div className="option__odds">Odds</div>
                  {this.props.loggedIn && this.state.proposition.coming && (
                    <div className="option__bet-input">New bet</div>
                  )}
                  <div className="option__main">Option</div>
                </div>

                <form
                  onSubmit={this.handleSubmit}
                  className="proposition__form"
                >
                  {this.state.proposition.options
                    .filter((option) => option.scratch === false)
                    .sort((a, b) =>
                      a.option.name > b.option.name
                        ? 1
                        : b.option.name > a.option.name
                        ? -1
                        : 0
                    )
                    .sort((a, b) =>
                      a.payout > b.payout ? 1 : b.payout > a.payout ? -1 : 0
                    )
                    .map((option) => (
                        <OptionComponent
                          key={option.id}
                          proposedTotal={this.proposedTotal()}
                          existingTotal={this.existingTotal()}
                          option={option}
                          loggedIn={this.props.loggedIn}
                          proposedBet={
                            this.state.proposedBets.filter(
                              (bet) => bet.option_data_id === option.id
                            )[0]
                          }
                          makeSingleBet={() => this.makeSingleBet}
                          availablePoints={this.props.player.points || 0}
                          proposition={this.state.proposition}
                          handleChange={this.handleChange}
                          loading={this.state.loading}
                          resetBet={() => this.resetBet}
                          addToBet={() => this.addToBet}
                          existingBets={
                            this.state.existingBets.filter(
                              (bet) => bet.selection.id === option.option.id
                            ) || [null]
                          }
                        />
                      ))}
                  {this.props.loggedIn &&
                    this.state.proposition &&
                    this.state.proposition.coming && (
                      <button
                        className="button--bet"
                        disabled={!this.validateBets(this.state.proposedBets)}
                      >
                        Make{" "}
                        {this.state.proposedBets.filter((bet) => bet.amount > 0)
                          .length > 1
                          ? "bets"
                          : "bet"}
                      </button>
                    )}
                </form>
              </div>
              <ScratchList
                scratches={this.state.proposition.options.filter(
                  (option) => option.scratch === true
                )}
              />

              <Histories
                winner={this.state.proposition.winner}
                favorite={this.state.favorite}
                options={this.state.proposition.options.filter(
                  (option: OptionData) => option.scratch === false
                )}
                mobile={true}
              />
            </section>
          </section>
        </article>
      );
    } else {
      return <LoadingBar />;
    }
  }
}

export default PropositionPage;
